// ----------------------------------------------------------------------------
// Snippet: Swatches
// ----------------------------------------------------------------------------
//
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_swatches.scss';

$(function() {
    $('.swatch-toggle').on('click', function() {
        const swatchType = $(this).attr('data-type');
        
        $('.swatch-toggle').removeClass('swatch-toggle--active');
        $('.swatch-toggle').attr('aria-selected', 'false');

        $(this).addClass('swatch-toggle--active');
        $(this).attr('aria-selected', 'true');

        $('.form__option-label').addClass('form__option-label--hidden');
        $('.swatch__option').addClass('swatch__option--hidden');

        $('.form__option-label--'+swatchType).removeClass('form__option-label--hidden');
        $('.form__option-label--'+swatchType).closest('.swatch__option').removeClass('swatch__option--hidden');
        
        $('.form__option-label--'+swatchType).closest('.form__field').attr('id','tab-panel-'+swatchType);
        
    });
    
    //Horizontal Arrow Naviation for Option Swatches
    $(".swatch__option").on("keydown", function(e) {
        var swatch_option                       = $(e.target).closest(".swatch__option");
        var swatch_option__active_label         = swatch_option.find("label:not(.form__option-label--hidden)");
        
        var swatch_option_next                  = swatch_option.next();
        var swatch_option_next__active_label    = swatch_option_next.find("label:not(.form__option-label--hidden)");
        
        var swatch_option_prev                  = swatch_option.prev();
        var swatch_option_prev__active_label    = swatch_option_prev.find("label:not(.form__option-label--hidden)");
        
        if (e.type === "keydown") {
            let key = e.key;
            if (key === "Tab") {
                $( ".swatch__option" ).each(function() {
                    $(this).find("label").removeClass("focus--js");
                });
                return;
            } else {
                switch(key) {
                    case "ArrowRight":  // right
                        // Moves focus to the next swatch option.
                        e.preventDefault();
                        // If focus is on the last item, moves focus to the first item.
                        if (swatch_option_next.find("label").length <= 0) {
                            $( ".swatch__option" ).each(function() {
                                var available_swatch = $(this).find("label:not(.form__option-label--hidden)");
                                if(available_swatch.length > 0) {
                                    swatch_option__active_label.removeClass("focus--js");
                                    available_swatch.trigger("click");
                                    available_swatch.addClass("focus--js");
                                    return false;
                                }
                            });
                        } else {
                            swatch_option__active_label.removeClass("focus--js");
                            
                            swatch_option_next__active_label.trigger("click");
                            swatch_option_next__active_label.addClass("focus--js");
                        }
                        break;
                    case "ArrowLeft": // left
                        // Moves focus to the previous item in the tablist.
                        e.preventDefault();
                        // If focus is on the first item, moves focus to the last item.
                        if (swatch_option_prev.find("label").length <= 0) {
                            swatch_option__active_label.removeClass("focus--js");
                            
                            var swatch_option__last = swatch_option.siblings(".swatch__option").last().find("label:not(.form__option-label--hidden)")
                            swatch_option__last.trigger("click");
                            swatch_option__last.addClass("focus--js");
                        } else {
                            swatch_option__active_label.removeClass("focus--js");
                            
                            swatch_option_prev__active_label.trigger("click");
                            swatch_option_prev__active_label.addClass("focus--js");
                        }
                        break;
                }
            }
        }
    });
    
    //Removes Manual Focus class for accessibility purposes
    $(".swatch__option label").on("click", function(e) {
        $( ".swatch__option" ).each(function() {
            $(this).find("label").removeClass("focus--js");
        });
    });
});